import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'
import { M3 } from '@messenger/consts'
import i18n from '../../../i18n'
import { escapeHtml } from '@messenger/utils'

export const madeInTemplate = ({ editorProps, firstInsertion = false }) => {
  const { funeralHomeDetails = {}, selectedTheme } = editorProps || {}
  const { ip_country_name = 'U.S.A.' } = funeralHomeDetails

  let country = typeof ip_country_name === 'string' ? ip_country_name : 'U.S.A.'
  const countryIsUnitedStates = country.trim().toLowerCase() === 'united states'
  if (countryIsUnitedStates) {
    country = 'U.S.A.'
  }

  // Dignity (MDL) products omit the "Printed in ... by Messenger" line entirely;
  // only the M3 storefront keeps it (with the country swapped via i18n above).
  // We still emit the made_in container so the dynamic-text anchor survives — on
  // re-render this empty container replaces any text baked into existing layouts,
  // and the update path stays idempotent.
  const isM3Theme = selectedTheme?.application === M3

  const madeInText = isM3Theme
    ? i18n.t(`editor.tinyMCE.insertDetail.printedInByMessenger`, { country }) ||
      `Printed in ${country} by Messenger`
    : ''
  const madeInParagraph = madeInText
    ? `<p><span>${escapeHtml(madeInText)}</span></p>`
    : ''

  const themeStyles = getThemeStylesForTemplate({
    selectedTheme,
    editor: editorProps.editor,
    firstInsertion,
  })

  const html = `
    <div data-template="made_in" class="mceNonEditable" style="${themeStyles}">
      ${madeInParagraph}
    </div>
  `

  return html
}

export default madeInTemplate
